import React from 'react';
import { useUserState } from '../User/UserContext';
export function isUserPermitted(userState, permissions) {
    const { permittedRoles, requiredFeatures, requiredModules } = permissions;
    if (permittedRoles &&
        !permittedRoles.some((role) => userState.user.roles[role])) {
        return {
            permitted: false,
            why: `User does not have at least one of the required roles: ${permittedRoles.join(' ')}`
        };
    }
    if (requiredFeatures &&
        !requiredFeatures.every((requiredFeature) => userState.features.enabledFeatures.includes(requiredFeature))) {
        return {
            permitted: false,
            why: `User does not have all of the required features enabled: ${requiredFeatures.join(' ')}`
        };
    }
    if (requiredModules &&
        !requiredModules.every((requiredModule) => userState.user.modules[requiredModule])) {
        return {
            permitted: false,
            why: `User does not have all of the required modules: ${requiredModules.join(' ')}`
        };
    }
    return { permitted: true, why: '' };
}
export const PermitRender = (props) => {
    const { children, permissions } = props;
    const userState = useUserState();
    const { permitted } = isUserPermitted(userState, permissions);
    return permitted ? React.createElement(React.Fragment, null, children) : React.createElement(React.Fragment, null);
};
//# sourceMappingURL=PermitRender.js.map